<script setup lang="ts">
// @ts-ignore
import { Container } from 'vue3-smooth-dnd';
import type { ContainerElement } from './types';
import { type FormElementConfig, FORM_ELEMENTS_CONFIG } from 'vince-core/pages/form-builder/constants';

const { t } = useI18n();

const props = defineProps<{
    container: ContainerElement;
}>();

const availableElements = computed((): FormElementConfig[] => {
    return FORM_ELEMENTS_CONFIG.filter(it => it.canBeAdded(props.container));
});

const childPayload = (index: number) => {
    return availableElements.value[index];
};

</script>
<template>
    <div class="flex flex-col h-full">
        <h3 class="font-light py-4">
            {{ t('formBuilder.elementsPaletteHeader') }}
        </h3>

        <container
            class="h-full overflow-scroll"
            behaviour="copy"
            drag-class="card-ghost"
            drop-class="card-ghost-drop"
            :get-child-payload="(index: number) => childPayload(index)"
        >
            <component
                :is="element.previewComponent"
                v-for="element in availableElements"
                :key="element.id"
                :element="element"
                class="element"
            />
        </container>
    </div>
</template>

<style scoped>
    .element {
        border: 1px solid grey;
        padding: 1rem;
        margin-bottom: 8px;
    }
</style>

